export default "__VITE_ASSET__8376caf4__"